import getBuiltIn$1 from './get-built-in.js';

var getBuiltIn = getBuiltIn$1;
var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

export { engineUserAgent as default };
